import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-my-data-viewer',
    imports: [RouterModule],
    templateUrl: './my-data-viewer.component.html',
    styleUrls: ['./my-data-viewer.component.scss']
})
export class MyDataViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  
  }

}
